import { TutorialDefinition } from '../TutorialEngine.js';
import { WallsRenderOptions } from './WallsTutorialAdapter.js';
import { COLORS } from '../../rendering/Renderer.js';

type WallsScene = {
    gameState: string;
    renderOptions: WallsRenderOptions;
    annotations: TutorialDefinition['scenes'][number]['annotations'];
    animate?: {
        interval: number;
        loop: boolean;
        frames: string[];
    };
};

// Full solution: E4F4N,E1E2E,A2B2S,A4A5E

const scenes: WallsScene[] = [
    // Scene 1: Goal — what a solved puzzle looks like
    {
        gameState: 'E4F4N,E1E2E,A2B2S,A4A5E',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'In Walls, place walls to\nguide a block through all digits', cell: 'C1', anchor: 'center', color: COLORS.teal },
        ],
    },

    // Scene 2: Basic movement, cycling walls
    {
        gameState: 'E2F2S,E4E5W,B4C4N,C1C2E,B0B1W',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click an edge\nto place a wall', cell: 'D0', anchor: 'center' },
            { type: 'text-label', text: 'Click again\nto cycle direction', cell: 'E1', anchor: 'center'},
            { type: 'text-label', text: 'Walls redirect the path', cell: 'C5', anchor: 'center' },
            { type: 'pulse', edge: '1121', color: COLORS.teal },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                'E2F2S',
                'E2F2S,E4E5W',
                'E2F2S,E4E5W,B4C4N',
                'E2F2S,E4E5W,B4C4N,C1C2E',
                'E2F2S,E4E5W,B4C4N,C1C2E,B0B1W',
                'E2F2S,E4E5W,B4C4N,C1C2E,B0B1E',
                'E2F2S,E4E5W,B4C4N,C1C2E',
            ],
        },
    },

    // Scene 3: Wrapping and automatic start
    {
        gameState: 'A4A5E,D4E4N,D1D2E,B2C2S',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Block wraps\naround edges', cell: 'E1', anchor: 'center'},
            { type: 'text-label', text: 'Start point chosen\nautomatically', cell: 'C5', anchor: 'center'},
        ],
    },

    // Scene 4: Adjacent walls (invalid, shown in red)
    {
        gameState: 'A2B2S,A4A5E,D1D2E,C1C2W,A4B4N',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Walls cannot\ntouch!', cell: 'C3', anchor: 'center', color: COLORS.red },
            { type: 'pulse', point: '32', color: COLORS.red },
            { type: 'pulse', point: '15', color: COLORS.red },
        ],
    },

    // Scene 5: No double digits
    {
        gameState: 'A2B2S,A4A5E,D4E4N,D2D3W,C1C2E',
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'A digit crossed\ntwice turns red', cell: 'B1', anchor: 'center', color: COLORS.red },
            { type: 'text-label', text: 'Loop points are\nmarked in amber', cell: 'C5', anchor: 'center', color: COLORS.amber },
        ],
    },

];

/**
 * Walls tutorial: 5 scenes on a 6x6 grid with digits 1-3.
 * See docs/tutorials/walls.md for detailed scene descriptions.
 */
export const WALLS_TUTORIAL: TutorialDefinition = {
    gameType: 'walls',
    gridCode: '6/1-3:1E2,2A3,3D4',
    scenes,
};
